import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
// import htmlToDraft from "html-to-draftjs";

const TextEditor = ({ msg, change, setMessageHtml, addAttachment }) => {
    // const convertedState = convertFromRaw(JSON.parse(msg))
    const contentState = ContentState.createFromText(msg);
    const editorValue = EditorState.createWithContent(contentState);
    const [editorState, setEditorState] = useState(editorValue);

    const updateTextDescription = (state) => {
        setEditorState(state);
        const data = convertToRaw(state.getCurrentContent());
        const html = draftToHtml(data);
        const textValues = data.blocks.map((val) => val.text);
        const text = textValues.join("\n");
        setMessageHtml(html);
        change(text);
    };
    const editorStyle = {
        width: "inherit",
        height: "300px",
        border: "1px solid blue",
        padding: "1rem",
    };

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const uploadCallback = (file, callback) => {
        return new Promise(async (resolve, reject) => {
            try {
                const payload = {
                    data: {
                        link: await toBase64(file),
                        name: "Name.jpg",
                    },
                };
                // Add attachment to list of attachments
                // addAttachment(file);
                return resolve(payload);
            } catch (error) {
                reject(error);
            }
        });
    };

    return (
        <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={updateTextDescription}
            editorStyle={editorStyle}
            toolbar={{
                image: {
                    uploadCallback,
                    urlEnabled: false,
                    previewImage: true,
                    // alt: { mandatory: true, present: true },
                },
            }}
        />
    );
};

export default TextEditor;
